<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card no-header>
          <b-tabs @input="setTabIndex" justified>
            <b-tab title="Datos del Organismo" active>
              <b-table class="datos-objeto" 
                  responsive="sm" 
                  :busy="tableBusy"
                  :items="impuestoOrganismoDatos" 
                  :fields="fields">
                <template v-slot:cell(valor)="data">
                  {{ formattedData(data.item) }}
                </template>
                <div slot="table-busy" class="text-center">
                  <b-spinner class="table-spinner" label="Spinning" />
                </div>              
              </b-table>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item @click.stop="editar">
            <i class="fa fa-edit"></i>Editar Datos del Organismo</b-dropdown-item>

          <b-dropdown-item @click.stop="consultarImpuestos">
            <i class="fa fa-user"></i>Consultar Impuestos</b-dropdown-item>

          <!-- <b-dropdown-item @click.stop="agregarImpuesto" 
              v-if="tabIndex == 2">
            <i class="fa fa-plus"></i>Agregar Impuesto</b-dropdown-item> -->

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>      
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'

const { mapFields } = createHelpers({
  getterType: 'impuestoOrganismo/getField',
  mutationType: 'impuestoOrganismo/updateField',
});

export default {
  name: 'ImpuestoOrganismoDatos',
  components: {
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [
    msjModal, 
    confirmModal,
    // exportPDFReciboCliente
  ],
  data: () => {
    return {
      id: 0,

      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      impuestosFields: [
        {
          key: 'nombre',
          sortable: true
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],
      tabIndex: 0,
      
      tableBusy: false,
    }
  },
  created() {
    this.id= this.$route.params.id

    this.getDatos();
  },  
  computed: {
    ...mapFields([
      'impuestoOrganismoDatos',
      // 'clienteObservaciones',
      /*
      'clienteAccionesDatos',
      'clienteContactosDatos',
      */
    //  'clienteContactosAdministracionDatos',
    ]),
  },  
  methods: {
    getDatos() {
      this.tableBusy = true;
      this.$store.dispatch('impuestoOrganismo/getDatos', this.id)
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    setTabIndex(e) {
      this.tabIndex = parseInt(e);
    },
    goBack() {
      this.$router.push({ name: 'ImpuestosOrganismos' });
    },
    editar() {
      this.$router.push({ name: 'ImpuestoOrganismoABM', 
                          params: { id: this.id }});
    },
    consultarImpuestos () {
      this.$router.push({ name: 'Impuestos', 
                          params: { impuestoOrganismoId: this.id }});
    },
  }
}
</script>

<style>
</style>